<template>
  <div class="view-layout-container">
    <div class="view-layout ly-container">
      <div class="view-layout-left">
        <slot name="layout-left">
          <div 
            v-for="menuItem in menuListTemp"
            :key="menuItem.path"
            :class="{
              'active': menuItem.active,
              'menu-item': true,
            }"
          >
            <img :src="menuItem.image" alt="">
            <router-link v-if="menuItem.path" :to="menuItem.path" class="name">
              <div class="name-zh">{{ menuItem.name }}</div>
              <div class="name-en">{{ menuItem.nameEn }}</div>
            </router-link>
            <a v-else :href="menuItem.fullLink" class="name" target="_blank">
              <div class="name-zh">{{ menuItem.name }}</div>
              <div class="name-en">{{ menuItem.nameEn }}</div>
            </a>
          </div>
        </slot>
      </div>
      <div class="view-layout-right">
        <slot>
          <!-- 内容 -->
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { deepClone } from '@/utils';

export default {
  name: 'Index',
  props: {
    menuList: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      menuListTemp: deepClone(this.menuList),
    };
  },
  mounted() {
    this.setActiveMenu(this.$route);
  },
  watch: {
    $route(to) {
      this.setActiveMenu(to);
    },
  },
  methods: {
    // 根据路由设置菜单选中状态
    setActiveMenu(currentRoute) {
      // 清空所有菜单选中状态
      this.menuListTemp.forEach(item => {
        item.active = false;
      });
      // 开始查找
      const list = this.menuListTemp;
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if (currentRoute.path.includes(element.path)) {
          this.menuListTemp[i].active = true;
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.view-layout {
  display: flex;
  padding: 40px 0;
  min-height: 50vh;
}
.view-layout-left {
  width: 280px;
}
.menu-item {
  height: 90px;
  background: url("@/assets/images/shape2.png") no-repeat;
  background-size: 100% 100%;
  color: inherit;
  // padding-left: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 40px;
    margin-right: 10px;
  }
  .name {
    color: inherit;
    cursor: pointer;
    .name-zh {
      font-size: 20px;
      letter-spacing: 2px;
    }
  }
  
  &.active {
    color: white; 
    background: url("@/assets/images/shape1.png") no-repeat;
    background-size: 100% 100%;
  }
}
.view-layout-right {
  flex: 1;
  padding-left: 20px;
  min-width: 0;
}

@media screen and (max-width: 768px) {
  .view-layout {
    flex-direction: column;
    padding: 20px 0;
  }
  .view-layout-left {
    width: 100%;
    padding-bottom: 20px;
  }
  .view-layout-right {
    width: 100%;
    padding-left: 0;
  }
  .menu-item {
    height: 50px;
    .name {
      font-size: 14px;
    }
    .name .name-zh {
      font-size: 16px;
    }
    > img {
      width: 40px;
      margin-right: 10px;
    }
  }
}
</style>
